import { baseApi } from './index';
import { AttachmentType } from 'models/AttachmentType';
import { TAG_TYPES, QueryParams } from 'types';
import { getQueryParams } from 'utils';

const urlEndpoint = `${process.env.REACT_APP_BASE_URL}/attachment-types`;
const tagType = TAG_TYPES.AttachmentType;

const attachmentTypeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET: Danh sách attachment types
    getAllAttachmentTypes: builder.query<
      { data: { rows: AttachmentType[]; count: number }; success: boolean },
      { query?: QueryParams }
    >({
      query: (params) => {
        const query = params?.query ? `?${getQueryParams(params.query)}` : '';
        return {
          url: `${urlEndpoint}${query}`,
          method: 'GET',
        };
      },
      providesTags: (result) => {
        const rows = result?.data?.rows && Array.isArray(result.data.rows) ? result.data.rows : [];
        if (rows.length > 0) {
          const itemTags = rows.map((item) => ({
            type: tagType,
            id: item.id,
          }));
          return [...itemTags, { type: tagType, id: 'LIST' }];
        }
        return [{ type: tagType, id: 'LIST' }];
      },
    }),

    // POST: Tạo mới attachment type
    createAttachmentType: builder.mutation<
      { data: AttachmentType; success: boolean },
      Partial<AttachmentType>
    >({
      query: (body) => ({
        url: urlEndpoint,
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: tagType, id: 'LIST' }],
    }),
  }),
});

export const {
  useGetAllAttachmentTypesQuery,
  useLazyGetAllAttachmentTypesQuery,
  useCreateAttachmentTypeMutation,
} = attachmentTypeApi;
